module.exports = __webpack_public_path__ + "img/rachit.c44b3c21.png";